<template>
  <div class="pagination-container" :class="lastNone ? 'lastNone':'lastBlock'">
    <el-pagination :background="background" :current-page.sync="currentPage" :page-size.sync="pageSize" :hide-on-single-page="false" :layout="layout" :page-sizes="pageSizes" :pager-count="pagerCount" prev-text="上一页" next-text="下一页" :total="total" v-bind="$attrs" @prev-click="upPage" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
  </div>
  <!-- <div :class="{ hidden: hidden }" class="pagination-container">
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :pager-count="pagerCount"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div> -->
</template>

<script>
import { scrollTo } from "@/utils/scroll-to";

export default {
  name: "Pagination",
  data() {
    return {
      lastNone: false
    }
  },
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [5, 10, 15];
      }
    },
    // 移动端页码按钮的数量端默认值5
    pagerCount: {
      type: Number,
      default: document.body.clientWidth < 992 ? 5 : 7
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next"
    },
    background: {
      type: Boolean,
      default: false
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit("update:page", val);
      }
    },
    pageSize: {
      get() {
        return this.limit;
      },
      set(val) {
        this.$emit("update:limit", val);
      }
    }
  },
  mounted() {
    this.lastLi()
  },
  methods: {
    lastLi() {
      this.$nextTick(() => {
        if (document.getElementsByClassName('btn-quicknext').length > 1) {
          if (!!document.getElementsByClassName('btn-quicknext')[0] || !!document.getElementsByClassName('btn-quicknext')[1]) {
              this.lastNone = true
          } else {
              this.lastNone = false
          }
        } else if (document.getElementsByClassName('btn-quicknext').length < 2) {
          if (!!document.getElementsByClassName('btn-quicknext')[0]) {
            this.lastNone = true
          } else {
            this.lastNone = false
          }
        }
      })
    },
    handleSizeChange(val) {
      this.$emit("changeSize"); // 每次更改条数，当前页面变1
      this.$emit("pagination", { page: this.currentPage, limit: val });
    },
    upPage(val) {
      this.$emit("upPage", { page: this.currentPage, limit: val });
    },
    handleCurrentChange(val) {
      this.$emit("pagination", { page: val, limit: this.pageSize });
    }
  }
};
</script>

<style scoped>
.pagination-container {
  text-align: right;
  /* background: #fff; */
  padding: 12px 16px;
}
/* .pagination-container.hidden {
  display: none;
} */
</style>
<style lang="less">
.lastNone {
  .el-pagination {
    .el-pager {
      li:nth-last-child(1) {
        display: none !important;
      }
    }
  }
}
.lastBlock {
  .el-pagination {
    .el-pager {
      li:nth-last-child(1) {
        display: inlibe-block !important;
      }
    }
  }
}
</style>
